"use client";

import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import type { NextPage } from "next";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { useOrganisation } from "@/providers/organisation-provider";

const HomePage: NextPage = () => {
    const router = useRouter();
    const organisation = useOrganisation();

    useEffect(() => {
        router.push("/auth/login");
    }, [router]);

    return (
        <Box alignItems="center" component="main" display="flex" height="100vh" justifyContent="center">
            <Stack alignItems="center" spacing={2}>
                <Typography variant="h2">{organisation.name}</Typography>
                <CircularProgress size={40} />
            </Stack>
        </Box>
    );
};

export default HomePage;
